"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const __1 = require("../../");
const normal_attack_1 = tslib_1.__importDefault(require("../common/normal-attack"));
const buff_skill_1 = tslib_1.__importDefault(require("../common/buff-skill"));
const skill_1 = require("../../skill");
exports.akajita_skill1 = new normal_attack_1.default('海扁');
exports.akajita_skill2 = new buff_skill_1.default(2, '鼓舞', 2, (_, sourceId, targetId) => [
    __1.Buff.build(sourceId, targetId)
        .name('鼓舞[速]')
        .countDown(2)
        .buffAP(__1.BattleProperties.SPD, __1.EffectTypes.FIXED, 15)
        .end(),
    __1.Buff.build(sourceId, targetId)
        .name('鼓舞[暴]')
        .countDown(2)
        .buffAP(__1.BattleProperties.CRI, __1.EffectTypes.FIXED, 0.11)
        .end()
]);
exports.akajita_skill3 = {
    no: 3,
    cost: 3,
    name: '风鼓雷',
    target: skill_1.SkillTarget.ENEMY,
    use(battle, sourceId, selectedId) {
        const selected = battle.getEntity(selectedId);
        const entities = battle.getTeamEntities(selected.teamId);
        function computed(battle, data) {
            const attack = data.attacks[data.index];
            if (!attack)
                return 0;
            if (battle.testHit(0.3) && attack.targetId) {
                battle.actionUpdateRunwayPercent(sourceId, attack.targetId, -1, __1.Reasons.SKILL);
            }
            return -1;
        }
        for (let i = 0; i < 2; i++) {
            const attacks = entities.map(e => __1.Attack.build(e.entityId, sourceId).rate(0.72).shouldComputeCri().group().completed(computed).end());
            if (!battle.actionAttack(attacks))
                return 0;
        }
        return -1;
    },
};
